import React, { Fragment } from 'react';
import usePageSeo from '../../hooks/usePageSeo';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import BlogList from '../../components/BlogList';


const BlogPage = (props) => {

    usePageSeo({
        title: 'Affordable Housing & Business Technology Blog',
        description: 'Insights from BUILDLAB on affordable housing technology, ISP negotiations, low-voltage design, managed IT, cyber security, and AI Business Integration.',
    });

    return (
        <Fragment>
            <Header />
            <main id="main-content" className="page_content blog-page">
                <PageTitle pageTitle={'Our Latest Blog'} pagesub={'Blogs'} pageTop={'Our'}/>
                <BlogList/>
            </main>
            <CtaSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogPage;
